import { showErrorMessage } from '@/components/common/errorMessage';

import Api from '@/api/Api';


const useProfileUpdate = (onStart, onSuccess, onError) => {
	const handleProfileUpdate = response => {
		if (response.status === 'ok') {
			onSuccess(response);
		} else {
			showErrorMessage(response.errors);
			onError(response);
		}
	}
	const profileUpdate = (profile, overrides) => {
		const profileCopy = (overrides != null) ? { ...profile, ...overrides } : { ...profile };
		onStart(profileCopy);
		Api.profileUpdate(profileCopy, handleProfileUpdate);
	}

	return {
		profileUpdate,
	}
}

export { useProfileUpdate };
